import { render, staticRenderFns } from "./VipGuests.vue?vue&type=template&id=aef6e214"
import script from "./VipGuests.vue?vue&type=script&lang=js"
export * from "./VipGuests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports